export default __webpack_public_path__ + "static/media/ico_bottom_arrow.c7449932.svg";